/* app/js/src/components/tenant/choose-template/enter-channel-name/enter-channel-name.component.scss */
:host {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10;
  display: none;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.cursor-pointer {
  cursor: pointer;
}
#enter-channel-name-container form input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
#enter-channel-name-container form input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
#enter-channel-name-container form input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
#enter-channel-name-container form input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
#enter-channel-name-container form input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
#enter-channel-name-container form input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
#enter-channel-name-container form input.ng-invalid.ng-dirty,
#enter-channel-name-container form input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
#enter-channel-name-container form .save-btn {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
#enter-channel-name-container form .save-btn:focus {
  outline-color: #ffffff;
}
#enter-channel-name-container form .save-btn:hover {
  background-color: white;
  color: #232f3a;
}
#enter-channel-name-container form .disabled.save-btn {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
:host {
  display: flex;
  animation-duration: 0.3s;
  animation-name: enter;
  position: fixed;
}
#enter-channel-name-container {
  position: fixed;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  padding: 22px 35px;
  font-size: 12px;
  width: 300px;
  height: 145px;
}
#enter-channel-name-container form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#enter-channel-name-container form input {
  padding: 0 0 0 15px;
  width: 225px;
}
#enter-channel-name-container form label {
  display: inline-block;
  font-size: 14px;
  margin-bottom: 5px;
}
#enter-channel-name-container form .save-btn {
  font-size: 11px;
  width: 120px;
  height: 30px;
  padding: 7px 17px;
  margin-top: 15px;
}
#enter-channel-name-container .x-sign {
  position: absolute;
  top: 13px;
  right: 13px;
  cursor: pointer;
}
/*# sourceMappingURL=enter-channel-name.component.css.map */
